// แคมเปญของแบรนด์ + ผูก KOL/Ads ไว้หรือยัง — ไม่ผูกกับช่วงเวลา จึงไม่มีปุ่มเลือกช่วง
import { Link } from "react-router";
import type { Campaign } from "@contracts/api";
import type { Brand } from "@contracts/api";
import { useCampaigns } from "@features/campaigns/api/use-campaigns";
import { brandCfgLink, menuPath } from "@features/navigation/model/side-menus";
import { fmtInt } from "@shared/lib/format";
import { cn } from "@shared/lib/utils";
import { OvKpi } from "../components/ov-kpi";
import { OvLoading } from "../components/ov-states";

export function CampaignListBlock({ brand }: { brand: Brand }) {
  const { data, isPending } = useCampaigns(brand.id);
  if (isPending) return <OvLoading />;

  const list = data ?? [];
  if (!list.length) {
    return (
      <div className="panel empty-state">
        <h3>ยังไม่มีแคมเปญ</h3>
        <p className="muted">
          สร้างได้ที่ <a href={brandCfgLink(brand)}>หน้าตั้งค่า → Campaigns</a>
        </p>
      </div>
    );
  }

  const has = (c: Campaign, kind: string) => (c.links ?? []).filter((l) => l.kind === kind);
  const withKol = list.filter((c) => has(c, "kol").length > 0).length;
  const withAds = list.filter((c) => has(c, "ads").length > 0).length;
  const campLink = menuPath(brand.id, "ads");

  return (
    <>
      <div className="ov-kpis">
        <OvKpi
          label="แคมเปญทั้งหมด"
          value={fmtInt(list.length)}
          sub={`${withKol} มี KOL · ${withAds} มี Ads`}
        />
      </div>
      <div className="panel ov-camp-list">
        {list.map((c) => (
          <Link key={c.id} className="ov-camp-row" to={campLink}>
            <span className="grow">
              <span className="camp-name">{c.name}</span>
            </span>
            <RunTag label="KOL" n={has(c, "kol").length} />
            <RunTag label="Biddable" n={has(c, "ads").length} />
            <span className="row-chev">›</span>
          </Link>
        ))}
      </div>
    </>
  );
}

function RunTag({ label, n }: { label: string; n: number }) {
  const on = n > 0;
  return (
    <span className={cn("run-tag", on && "on")}>
      {on ? "● " : "○ "}
      {label}
      {on ? " " + n : ""}
    </span>
  );
}
